import axiosInstance from "./axios-instance";
import { isMutationSuccess } from "./cache-utils";
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const withScopedAccountId = (payload: any) => {
    if (!payload || typeof payload !== "object") {
        return payload;
    }

    const scopedAccountId = getScopedAccountId(payload.accountId);
    if (!(scopedAccountId > 0)) {
        return payload;
    }

    return {
        ...payload,
        accountId: scopedAccountId,
    };
};

const addDraperyOrderFabric = async (payloadRecieved: any) => {
    try {
        const scopedPayload = withScopedAccountId(payloadRecieved);
        let payload = {
            ...scopedPayload,
            values: {
                ...scopedPayload.values,
                fabricWidth:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.fabricWidth !== "" &&
                    scopedPayload.values.fabricWidth !== null &&
                    scopedPayload.values.fabricWidth >= 0
                        ? parseFloat(scopedPayload.values.fabricWidth)
                        : scopedPayload.noValue || null,
                horizontalRepeat:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.horizontalRepeat !== "" &&
                    scopedPayload.values.horizontalRepeat !== null &&
                    scopedPayload.values.horizontalRepeat >= 0
                        ? parseFloat(scopedPayload.values.horizontalRepeat)
                        : scopedPayload.noValue || null,
                verticalRepeat:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.verticalRepeat !== "" &&
                    scopedPayload.values.verticalRepeat !== null &&
                    scopedPayload.values.verticalRepeat >= 0
                        ? parseFloat(scopedPayload.values.verticalRepeat)
                        : scopedPayload.noValue || null,
                trimWidth:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.trimWidth !== "" &&
                    scopedPayload.values.trimWidth !== null &&
                    scopedPayload.values.trimWidth >= 0
                        ? parseFloat(scopedPayload.values.trimWidth)
                        : scopedPayload.noValue || null,
            },
        };

        const response = await axiosInstance.post<any>(
            "/draperyOrderFabric/add",
            payload
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

        return response.data;
    } catch (error) {
        console.error("Error add drapery order fabric:", error);
        throw error;
    }
};

const editDraperyOrderFabric = async (payloadRecieved: any) => {
    try {
        const scopedPayload = withScopedAccountId(payloadRecieved);
        let payload = {
            ...scopedPayload,
            values: {
                ...scopedPayload.values,
                fabricWidth:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.fabricWidth !== "" &&
                    scopedPayload.values.fabricWidth !== null &&
                    scopedPayload.values.fabricWidth >= 0
                        ? parseFloat(scopedPayload.values.fabricWidth)
                        : scopedPayload.noValue || null,
                horizontalRepeat:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.horizontalRepeat !== "" &&
                    scopedPayload.values.horizontalRepeat !== null &&
                    scopedPayload.values.horizontalRepeat >= 0
                        ? parseFloat(scopedPayload.values.horizontalRepeat)
                        : scopedPayload.noValue || null,
                verticalRepeat:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.verticalRepeat !== "" &&
                    scopedPayload.values.verticalRepeat !== null &&
                    scopedPayload.values.verticalRepeat >= 0
                        ? parseFloat(scopedPayload.values.verticalRepeat)
                        : scopedPayload.noValue || null,
                trimWidth:
                    scopedPayload &&
                    scopedPayload.values &&
                    scopedPayload.values.trimWidth !== "" &&
                    scopedPayload.values.trimWidth !== null &&
                    scopedPayload.values.trimWidth >= 0
                        ? parseFloat(scopedPayload.values.trimWidth)
                        : scopedPayload.noValue || null,
            },
        };

        const response = await axiosInstance.put<any>(
            "/draperyOrderFabric/edit",
            payload
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

        return response.data;
    } catch (error) {
        console.error("Error edit drapery order fabric:", error);
        throw error;
    }
};

const deleteDraperyOrderFabric = async (payload: any) => {
    try {
        const response = await axiosInstance.post<any>(
            "/draperyOrderFabric/delete",
            payload
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }

        return response.data;
    } catch (error) {
        console.error("Error delete drapery order fabric:", error);
        throw error;
    }
};

const getDraperyOrderFabricsByIds = async(ids: any) => {
    try{
        const response = await axiosInstance.post<any>("/draperyOrderFabric/get-by-ids", ids);
        return response.data;
    } catch(error){
        console.error("Error get drapery order fabrics:", error);
        throw error;
    }
   
}

export {
    addDraperyOrderFabric,
    editDraperyOrderFabric,
    deleteDraperyOrderFabric,
    getDraperyOrderFabricsByIds
};
